<template>
  <!-- 纠错弹框 -->
  <el-dialog
    class="uni-error-modal"
    title="提示"
    :visible.sync="isVisible"
    width="50%"
    @closed="updateVisible"
  >
    <div class="title">
      <img
        class="mar20"
        style="width: 60px; height: 62px"
        src="@/assets/images/jc.png"
        alt=""
      />
      一直在完善，从未停歇过，但有些题目可能仍然存在瑕疵，对您造成的不便我们深表歉意
    </div>

    <el-radio-group class="err-radio" v-model="errorType">
      <el-radio
        v-for="item in errorList"
        :key="item"
        class="radio"
        :label="item"
        >{{ item }}</el-radio
      >
    </el-radio-group>

    <div class="textarea-box">
      <el-input
        v-model="content"
        type="textarea"
        rows="5"
        placeholder="请输入纠正内容（200字以内）"
        maxlength="200"
        show-word-limit
      ></el-input>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="refer-btn" type="primary" @click="saveTopicError"
        >提交</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { postCorrect } from "@/api/basic";
export default {
  name: "ComponentCorrect",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 题目id
    topicId: {
      type: [Number, String]
    },
  },
  data() {
    return {
      errorList: [
        "含有错别字",
        "答案不正确",
        "题目不完整",
        "图片不存在",
        "解析不正确",
        "其它错误",
      ],
      isVisible: false,
      errorType: "含有错别字",
      content: "",
    };
  },
  watch: {
    visible(val) {
      this.isVisible = val;
    },
  },
  methods: {
    /**
     * 提交
     */
    updateVisible() {
      this.$emit("update:visible", false);
    },
    /**
     * 纠错
     */
    async saveTopicError() {
      if (!this.content) {
        this.$message.error("内容不能为空");
        return;
      }
      const params = {
        error_describe: this.content,
        error_type: this.errorType,
        question_id: this.topicId,
      };
      const res = await postCorrect(params);
      if (res) {
        this.content = "";
        this.errorType = "含有错别字";
        this.$message.success("提交成功");
        this.updateVisible();
      }
    },
  },
};
</script>

<style lang="scss">
.uni-error-modal {
  .el-collapse-item__header {
    background: $grayBgLight;
    padding: 0 20px;
    height: auto;
  }

  .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
  }

  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 50px;
  }
  .el-dialog__header {
    border-bottom: 1px solid $grayBorder;
  }
  .el-textarea__inner {
    border: none;
    outline: none;
    background: $grayInputBg;
  }
}
</style>
<style lang="scss" scoped>
.uni-error-modal {
  .title {
    color: $textColor;
    .iconfont {
      font-size: 56px;
      margin-right: 25px;
      vertical-align: middle;
    }
  }
  .err-radio {
    .radio {
      margin-top: 15px;
    }
  }

  .textarea-box {
    margin-top: 25px;
  }

  .dialog-footer {
    .refer-btn {
      width: 110px;
      height: 34px;
      padding: 0;
    }
  }
}
</style>
